import { render, staticRenderFns } from "./ModalAlertError.vue?vue&type=template&id=0c70aa15&scoped=true&"
import script from "./ModalAlertError.vue?vue&type=script&lang=js&"
export * from "./ModalAlertError.vue?vue&type=script&lang=js&"
import style0 from "./ModalAlertError.vue?vue&type=style&index=0&id=0c70aa15&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c70aa15",
  null
  
)

export default component.exports